import { render, staticRenderFns } from "./StudyPolicy.vue?vue&type=template&id=065e74db&scoped=true&"
import script from "./StudyPolicy.vue?vue&type=script&lang=js&"
export * from "./StudyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./StudyPolicy.vue?vue&type=style&index=0&id=065e74db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065e74db",
  null
  
)

export default component.exports